import DocumentsList from '../DocumentsList';

export const SupervisorStudentDocumentList = () => {
  return <DocumentsList containsCollaborationFiles={true} />;
};
